import type { RouteRecordRaw } from "vue-router";

const Layout = () => import("@/layout/index.vue");

const teacherManagementRoutes: RouteRecordRaw = {
  path: "/teacherManagement",
  component: Layout,
  redirect: "/teacherManagement/teacherList",
  name: "TeacherManagement",
  meta: {
    title: "教师管理",
    icon: "homepage",
    permissionKey: "system:teacherList",
  },
  children: [
    {
      path: "teacherList",
      name: "TeacherList",
      component: () =>
        import("@/views/Workbench/teacher-management/teacher-list/index.vue"),
      meta: {
        title: "教师列表",
        icon: "homepage",
        permissionKey: "system:teacherList",
      },
    },
    {
      path: "userSchoolAuth",
      name: "TeacherUserSchoolAuth",
      component: () =>
        import("@/views/Workbench/teacher-management/user-school-auth/index.vue"),
      meta: {
        title: "学校授权",
        hidden: true,
        icon: "homepage",
        permissionKey: "system:userSchoolAuth",
      },
    },
    {
      path: "userSchoolAuthAll",
      name: "TeacherUserSchoolAuthAll",
      component: () =>
        import("@/views/Workbench/teacher-management/user-school-auth-all/index.vue"),
      meta: {
        title: "批量学校授权",
        hidden: true,
        icon: "homepage",
        permissionKey: "system:userSchoolAuthAll",
      },
    },
  ],
};

export default teacherManagementRoutes;
